// extracted by mini-css-extract-plugin
export default {"contactDetailsWrapper":"ON2552","isMobile":"bpfi_7","inputContainer":"u3alaD","isHighlighted":"jwbUIL"};